<template>
  <div>
    <!-- DO NOT REMOVE BELOW DIV -->
    <div class="error-message"></div>


    <ad v-if="!isMobileAds" v-on:ad-loaded="updateAdCounter" :ad-object="firstAd" :no-margin="hideFirstDesktopAd"></ad>
    <div class="columns is-hidden-tablet is-full-mobile">
      <div class="column is-paddingless">
        <div class="tabs">
          <ul>
            <li :class="{ 'is-active': showReviewTab }"><a @click.prevent="changeMobileTabs">Reviews</a></li>
            <li :class="{ 'is-active': showDetailsTab }"><a @click.prevent="changeMobileTabs">Company details</a></li>
          </ul>
        </div>
      </div>
    </div>
    <!-- Desktop View STARTS -->
    <div v-if="!isMobileAds" class="is-hidden-mobile">
      <div class="columns">
        <div class="column is-narrow">
          <p class="filter-text">Filter reviews:</p>
        </div>
        <div class="column">
          <star-radio-filter :default-star="selectedStarFilter" v-on:changed="ratingFilterChanged"></star-radio-filter>
        </div>
      </div>
      <p class="has-text-left">Show reviews that mention:</p>
      <div class="field">
        <p class="control has-icons-right">
          <input class="input" type="text" placeholder="Search for reviews that mention..." @change="keywordChanged" />
          <span class="icon is-small is-right"><i class="fas fa-search"></i></span>
        </p>
      </div>
      <ad v-if="!isMobileAds" v-on:ad-loaded="updateAdCounter" :ad-object="secondAd"></ad>
      <p v-if="fetching_data" class="has-text-centered spinner"><img src="/static/img/spinner.svg" alt="Getting reviews" /></p>
      <div v-if="!fetching_data" class="columns is-multiline is-hidden-mobile">
        <div v-for="(reviewItem, index) in items" class="column is-full-tablet">
          <!-- Business Review Listing Cards Begin -->
          <biz-list-review-card
            :reviewIndex="index"
            :review="reviewItem"
            :show-business-avatar="showBusinessInReviewCards"
          >
          </biz-list-review-card>
          <!-- Business Review Listing Cards End -->
        </div>
      </div>
      <paginator :dataSet="dataSet" @changed="fetchReviews"></paginator>
      <ad v-if="!isMobileAds" v-on:ad-loaded="updateAdCounter" :ad-object="sixthAd"></ad>
    </div>
    <!-- Desktop View ENDS -->

    <!-- Mobile View STARTS -->
    <!-- MOBILE REVIEW TAB START -->
    <div v-if="showReviewTab && isMobileAds" class="is-hidden-tablet">
      <div class="columns">
        <div class="column is-narrow">
          <p class="filter-text">Filter reviews:</p>
        </div>
        <div class="column">
          <star-radio-filter :default-star="selectedStarFilter" v-on:changed="ratingFilterChanged"></star-radio-filter>
        </div>
      </div>
      <p class="has-text-left">Show reviews that mention:</p>
      <div class="field">
        <p class="control has-icons-right">
          <input class="input" type="text" placeholder="Search for reviews that mention..." @change="keywordChanged" />
          <span class="icon is-small is-right"><i class="fas fa-search"></i></span>
        </p>
      </div>
      <p v-if="isMobileAds" class="has-text-centered"><ad v-on:ad-loaded="updateAdCounter" :ad-object="firstAd"></ad></p>
      <p v-if="fetching_data" class="has-text-centered spinner"><img src="/static/img/spinner.svg" alt="Getting reviews" /></p>
      <div v-if="!fetching_data" class="columns is-multiline is-hidden-tablet">
        <div v-for="(reviewItem, index) in items" class="column is-full-mobile is-paddingless">
          <!-- Business Review Listing Cards Begin -->
          <biz-list-review-card
            :reviewIndex="index"
            :review="reviewItem"
            :show-business-avatar="showBusinessInReviewCards"
          >
          </biz-list-review-card>
          <!-- Business Review Listing Cards End -->
          <p v-if="isMobileAds && index === 4" class="has-text-centered"><ad v-on:ad-loaded="updateAdCounter" :ad-object="secondAd"></ad></p>
<!--          <leader-board-medium :no-top-margin="mobileAdNoTopMargin" v-if="index === 4"></leader-board-medium>-->
        </div>
        <p v-if="isMobileAds" class="has-text-centered"><ad v-on:ad-loaded="updateAdCounter" :ad-object="thirdAd"></ad></p>
<!--        <leader-board-medium :half-top-margin="mobileAdNoTopMargin"></leader-board-medium>-->
      </div>
      <paginator :dataSet="dataSet" @changed="fetchReviews"></paginator>
    </div>
    <!-- MOBILE REVIEW TAB ENDS -->

    <!-- MOBILE BUSINESS DETAILS TAB START -->
    <div v-if="showDetailsTab && isMobileAds" class="is-hidden-tablet">
      <div class="level is-mobile">
        <div v-if="totalReviews >= 10" class="level-item container-box">
          <p>RANKING</p>
          <p v-text="industryRankingHtml"></p>
          <p v-html="industryNameHtml"></p>
        </div>
        <div v-if="totalReviews < 10" class="level-item container-box">
          <p class="no-nps-data line-heigth-23" style="margin:0 auto;" v-html="notEnoughReviewsText"></p>
        </div>
        <div class="level-item container-box">
          <div v-if="hasNpsData" class="bottom-right nps-component-icon" @click="showTooltip = !showTooltip">
            <i class="is-pulled-right is-fixed-top fas fa-info-circle"></i>
          </div>
          <div v-if="hasNpsData" class="nps-total" v-text="getNpsTotal"></div>
          <p v-if="hasNpsData">RECOMMENDED TO A FRIEND</p>
          <p class="no-nps-data" v-if="!hasNpsData">No NPS data available</p>

          <v-popover
              trigger="manual"
              :open="showTooltip"
              placement="bottom-start"
          >
            <template slot="popover">
              <p>This score indicates how likely it is for reviewers to recommend this business. Less than 0 = unlikely, 1 to 49 = likely and above 49 = very likely. For more information on how the NPS is collected and calculated,
                <a target="_blank" href="https://blog.hellopeter.com/faqs/your-net-promoter-score">read more here</a>.</p>
            </template>
          </v-popover>
        </div>
      </div>
      <div class="container">
<!--        <leader-board-medium></leader-board-medium>-->
        <p v-if="isMobileAds" class="has-text-centered"><ad v-on:ad-loaded="updateAdCounter" :ad-object="fourthAd"></ad></p>
        <div v-if="showRatingsChart">
          <star-rating-widget
                  :top-margin-small="smallTopMargin"
                  :short-summary="starDescriptionText"
                  :smaller-font-size="starDescriptionText"
                  :white-back-ground="starDescriptionText"
                  :box-shadow="starDescriptionText"
                  :final-score="averageRating"
                  :total-reviews="totalReviews"
                  :one="oneStar"
                  :two="twoStar"
                  :three="threeStar"
                  :four="fourStar"
                  :five="fiveStar"
                  :star-description-text="starDescriptionText"
                  :hide-logo="starDescriptionText"
                  :hide-summary="starDescriptionText"></star-rating-widget>
        </div>
        <h4 class="has-text-weight-bold">Month on month industry ranking</h4>
        <div class="columns is-marginless is-mobile">
          <div v-for="monthRecord in monthRecords" class="industry-rank-card column">
            <p class="has-text-centered"><span class="has-text-weight-bold">#{{ monthRecord.industryRanking }}</span><br/><span v-text="monthRecord.month"></span></p>
          </div>
        </div>
        <h4 class="has-text-weight-bold">Month on month TrustIndex</h4>
        <vue-chart chart-type="ComboChart" :columns="trustIndexOverTimeColumns" :rows="trustIndexOverTimeRows" :options="trustIndexOverTimeOptions"></vue-chart>
<!--        <leader-board-medium></leader-board-medium>-->
        <p v-if="isMobileAds" class="has-text-centered"><ad v-on:ad-loaded="updateAdCounter" :ad-object="fifthAd"></ad></p>
        <h4 v-if="hasBusinessDescription || hasWebsite" class="has-text-weight-bold" v-html="aboutText"></h4>
        <p v-if="hasPaidSubscription && hasBusinessDescription" class="business-description" v-text="record.businessDetails.description"></p>
        <a v-if="hasWebsite" class="button is-outlined is-fullwidth" rel="nofollow" target="_blank" :href="record.businessDetails.website">VISIT OUR WEBSITE</a>
        <h4 v-if="hasSocialLinks || hasBusinessAddress || hasBusinessEmail || hasBusinessPhone" class="has-text-weight-bold" v-html="connectWithText"></h4>
        <div v-if="hasPaidSubscription && hasSocialLinks" class="columns is-mobile">
          <div v-for="socialLink in socialLinks" class="column">
            <a :href="socialLink.url" target="_blank" rel="nofollow" :class="socialLink.style"><i :class="socialLink.icon"></i></a>
          </div>
          <div v-for="socialLinkOffset in socialLinksOffset" class="column">&nbsp;</div>
        </div>
        <p v-if="hasBusinessAddress" class="mini-title has-text-weight-bold">Where we live:</p>
        <p v-if="hasBusinessAddress" class="has-text-left mini-detail" v-html="record.businessDetails.address"></p>
        <p v-if="hasPaidSubscription && hasBusinessEmail" class="mini-title has-text-weight-bold">Write to us:</p>
        <p v-if="hasPaidSubscription && hasBusinessEmail" class="has-text-left mini-detail" v-html="record.businessDetails.email"></p>
        <p v-if="hasPaidSubscription && hasBusinessPhone" class="mini-title has-text-weight-bold">Call us on:</p>
        <p v-if="hasPaidSubscription && hasBusinessPhone" class="has-text-left mini-detail aaaaa" v-html="record.businessDetails.tel"></p>
        <p v-if="isMobileAds && (hasSocialLinks || hasBusinessAddress || hasBusinessEmail || hasBusinessPhone)" class="has-text-centered"><ad v-on:ad-loaded="updateAdCounter" :ad-object="sixthAd"></ad></p>
<!--        <leader-board-medium v-if="hasSocialLinks || hasBusinessAddress || hasBusinessEmail || hasBusinessPhone"></leader-board-medium>-->
        <h4 v-if="hasKeywords" class="has-text-weight-bold">Popular keywords:</h4>
        <p v-if="hasKeywords" class="has-text-left mini-detail">
          <span v-for="keyword in keywords" class="tag is-white" v-html="keyword"></span>
        </p>
<!--        <leader-board-medium v-if="hasKeywords"></leader-board-medium>-->
        <p v-if="isMobileAds && hasKeywords" class="has-text-centered"><ad v-on:ad-loaded="updateAdCounter" :ad-object="seventhAd"></ad></p>
      </div>
    </div>
    <!-- MOBILE BUSINESS DETAILS TAB ENDS -->
    <!-- Mobile View STARTS -->

  </div>
</template>
<script>
  /* global googletag */
  /* eslint-disable indent,no-new,no-undef */

  import qs from 'qs'
  import axios from 'axios'
  import LeaderBoardMedium from '@/components/LeaderBoardMedium'
  import collection from '../../mixins/collection.js'
  import StarRatingWidget from '@/components/StarRatingWidget'
  import StarRadioFilter from '@/components/StarRadioFilter'
  import Paginator from '@/components/Paginator'
  import ReviewCard from '@/components/ReviewCard'
  import LeaderBoardMobile from '@/components/LeaderBoardMobile'
  import LeaderBoardMobileSecondary from '@/components/LeaderBoardMobileSecondary'
  import FlashMessage from '@/components/FlashMessage'
  import BizListReviewCard from '@/components/BizListReviewCard'
  import adsConfig from '@/mixins/ad_config'
  import Ad from '@/components/ProgrammaticAds'

  export default {
    name: 'BusinessReviews',
    props: {
      business: {
        type: String
      }
    },
    components: {
      LeaderBoardMobile,
      LeaderBoardMobileSecondary,
      StarRadioFilter,
      Paginator,
      ReviewCard,
      LeaderBoardMedium,
      StarRatingWidget,
      FlashMessage,
      BizListReviewCard,
      Ad
    },
    mixins: [collection, adsConfig],
    data () {
      return {
        isMobileAds: false,
        mobileAdNoTopMargin: true,
        adWait: true,
        businessDetailLoaded: false,
        businessStatsLoaded: false,
        pagination: {
          last_page: 0,
          current_page: 0
        },
        firstReviewsFetch: false,
        current_review_fetch_url: '',
        selectedStarFilter: 0,
        socialLinks: [],
        socialLinksOffset: [{}, {}, {}, {}, {}],
        showBusinessInReviewCards: false,
        dataSet: false,
        total_records: 0,
        fetching_data: false,
        reviews_per_page: undefined,
        keyword_search: '',
        keywords: [],
        filter_search: '',
        showReviewTab: true,
        showDetailsTab: false,
        backgroundColors: [
          '#88397F',
          '#394B88',
          '#39887C',
          '#885A39',
          '#88397F',
          '#394B88',
          '#39887C',
          '#885A39'
        ],
        record: null,
        smallTopMargin: true,
        starDescriptionText: true,
        averageRating: 0,
        totalReviews: 0,
        stats: undefined,
        oneStar: 0,
        twoStar: 0,
        threeStar: 0,
        fourStar: 0,
        fiveStar: 0,
        monthRecords: [],
        trustIndexOverTimeColumns: [],
        trustIndexOverTimeRows: [],
        trustIndexOverTimeOptions: {
          title: '',
          legend: 'none',
          vAxis: {
            title: '',
            textStyle: {
              color: '#7b7c7e',
              bold: true
            },
            viewWindow: { max: 10 },
            viewWindowMode: 'explicit'
          },
          hAxis: {
            title: '',
            textStyle: {
              color: '#7b7c7e'
            }
          },
          height: 450,
          width: '100%',
          pointSize: 10,
          series: {
            0: {
              type: 'line',
              color: '#30AAE1'
            }
          },
          chartArea: {
            'width': '90%',
            'height': '80%',
            top: '9%',
            bottom: '50%',
            left: '10%'
          }
        },
        showTooltip: false
      }
    },
    created () {
      this.isMobileAds = window.innerWidth <= 767
      let that = this
      window.events.$on('refreshReviewDetail',()=>{
        this.current_review_fetch_url = ''
        this.fetchReviews(1)
      });
      window.events.$on('loaded-business-stats', (data) => {
        this.stats = data.stats
        this.totalReviews = data.totalReviews
        this.averageRating = data.averageRating
        this.monthRecords = data.monthRecords
        this.oneStar = data.oneStar
        this.twoStar = data.twoStar
        this.threeStar = data.threeStar
        this.fourStar = data.fourStar
        this.fiveStar = data.fiveStar
        this.pagination = data.pagination
        this.businessStatsLoaded = true
      })
      window.events.$on('loaded-business-details', (data) => {
        window.events.$off('loaded-business-details')
        this.record = data.record
        this.socialLinks = data.socialLinks
        this.socialLinksOffset = data.socialLinksOffset
        let trackEvent = {
            event: 'pageLoad',
            virtualPageUrl: this.$router.currentRoute.path,
            virtualPageTitle: this.metaTitle,
            brandName: this.record.businessName,
            industryName: this.record.industryName
        }
        if (data.bizCategories.length > 0) {
            data.bizCategories.forEach(function(v,i){
                i++
                if (i >= 16) return false
                let key  = 'category' + that.digitToWords(i).charAt(0).toUpperCase() + that.digitToWords(i).slice(1)
                trackEvent[key] = v.category.name
            })
        }
        if (!window.pageTracked) {
          window.pageTracked = true
          this.$gtm.trackEvent(trackEvent)
        }
        this.businessDetailLoaded = true
      })
      window.events.$on('loaded-business-month-on-month-graph', (data) => {
        this.trustIndexOverTimeRows = data.trustIndexOverTimeRows
        this.trustIndexOverTimeColumns = data.trustIndexOverTimeColumns
        this.trustIndexOverTimeOptions = data.trustIndexOverTimeOptions
      })
      window.events.$on('loaded-business-keywords', (data) => {
        this.keywords = data.keywords
      })
      if (this.$route.query.already_written_review_for_invite) {
        flash('You have already written a review for this business.', 'is-danger')
      }
      let query = location.search.match(/page=(\d+)/)
      let page = query ? query[1] : 1
      this.fetchReviews(page)
      if (this.business.toLowerCase() !== 'absa') {
        this.loadAds()
        if (!this.isMobileAds) {
          const desktopAdsArray = [
            this.thirdAd,
            this.fourthAd,
            this.fifthAd
          ]
          window.events.$emit('business-detail-desktop-ads', desktopAdsArray)
        }
      }
    },
    metaInfo () {
      return {
        title: this.metaTitle,
        titleTemplate: '%s | Hellopeter.com',
        meta: this.metaDescription,
        link: this.getMetaLinks,
        bodyAttrs: {
          class: 'business'
        }
      }
    },
    computed: {
      getMetaLinks () {
        let links = []
        if (this.record !== null && typeof this.record.businessDetails !== 'undefined' && (this.pagination.current_page > 0 || this.pagination.last_page > 0)) {
          links.push({ rel: 'canonical', href: `${window.location.protocol}//${window.location.host}/${this.record.businessDetails.slug}` })
          if (this.pagination.current_page === 1) {
            if (this.pagination.last_page > 0) {
              links.push({ rel: 'next', href: `${window.location.protocol}//${window.location.host}${this.$route.path}?page=${(this.pagination.current_page + 1)}` })
            }
            links.push({ rel: 'prev', href: `${window.location.protocol}//${window.location.host}/${this.record.businessDetails.slug}`})
          } else {
            if (this.pagination.current_page !== this.pagination.last_page) {
              links.push({ rel: 'next', href: `${window.location.protocol}//${window.location.host}${this.$route.path}?page=${(this.pagination.current_page + 1)}` })
            } else {
              links.push({ rel: 'next', href: `${window.location.protocol}//${window.location.host}${this.$route.path}?page=${(this.pagination.current_page)}` })
            }
            links.push({ rel: 'prev', href: `${window.location.protocol}//${window.location.host}${this.$route.path}?page=${(this.pagination.current_page - 1)}`})
          }
        }
        return links
      },
      metaTitle () {
        if (this.record !== null) {
          return `${this.record.businessName} Reviews | Contact ${this.record.businessName} - ${this.record.industryName} - ${this.record.trustIndex} TrustIndex`
        }
        return ''
      },
      metaDescription () {
        let metaObjects = []
        if (this.record !== null && typeof this.record !== 'undefined' && typeof this.record.businessName !== 'undefined' && typeof this.record.businessDetails !== 'undefined') {
          let description = `${this.record.businessName} reviews, customer feedback & support. Contact & review ${this.record.businessName}`

          if (this.record.industryRanking < 50) {
            description += ` - rated #${this.record.industryRanking} in ${this.record.industryName}`
          }

          const avgResponseTime = parseInt(this.record.businessDetails.averageResponseTime)

          if (avgResponseTime < 24 && this.record.businessDetails.responding) {
            description += ` - get a reply from ${this.record.businessName} within an avg of ${avgResponseTime} hours`
          }

          metaObjects.push({ name: 'description', content: description})

          if (this.$route.query.page) {
            metaObjects.push({ name: 'ROBOTS', content: 'NOINDEX, FOLLOW' })
          }
        }
        return metaObjects
      },
      industryRankingHtml () {
        if (this.record != null) {
          return `#${this.record.industryRanking}`
        }
        return 'N/A'
      },
      industryNameHtml () {
        if (this.record !== null) {
          const slug = this.record.industrySlug
          const name = this.record.industryName.toUpperCase()
          return `IN <a href="/industries/${slug}">${name}</a>`
        }
        return ''
      },
      getNpsTotal () {
        if (this.record !== null && typeof this.record.nps !== 'undefined') {
          return this.record.nps.nps_total
        }
        return 0
      },
      hasNpsData () {
        return this.record !== null &&
          typeof this.record.nps !== 'undefined' &&
          (this.record.nps.detractors > 0 ||
            this.record.nps.passives > 0 ||
            this.record.nps.promoters > 0 ||
            this.record.nps.totalRespondents > 0)
      },
      hasBusinessDescription () {
        return this.record !== null &&
          typeof this.record.businessDetails !== 'undefined' &&
          typeof this.record.businessDetails.description === 'string' &&
          this.record.businessDetails.description.length > 0
      },
      hasWebsite () {
        return this.record !== null &&
          typeof this.record.businessDetails !== 'undefined' &&
          typeof this.record.businessDetails.website === 'string' &&
          this.record.businessDetails.website.length > 0
      },
      aboutText () {
        if (this.record !== null) {
          return `About ${this.record.businessName}:`
        }
        return ''
      },
      connectWithText () {
        if (this.record !== null) {
          return `Connect with ${this.record.businessName}:`
        }
        return ''
      },
      hasSocialLinks () {
        return typeof this.socialLinks !== 'undefined' && this.socialLinks.length > 0
      },
      hasBusinessAddress () {
        return this.record !== null &&
          typeof this.record.businessDetails !== 'undefined' &&
          typeof this.record.businessDetails.address === 'string' &&
          this.record.businessDetails.address.length > 6
      },
      hasBusinessEmail () {
        return this.record !== null &&
          typeof this.record.businessDetails !== 'undefined' &&
          typeof this.record.businessDetails.email === 'string' &&
          this.record.businessDetails.email.length > 0
      },
      hasBusinessPhone () {
        return this.record !== null &&
          typeof this.record.businessDetails !== 'undefined' &&
          typeof this.record.businessDetails.tel === 'string' &&
          this.record.businessDetails.tel.length > 0
      },
      hasKeywords () {
        return typeof this.keywords !== 'undefined' && this.keywords.length > 0
      },
      showAdThree () {
        return true
      },
      showAdFour () {
        return true
      },
      notEnoughReviewsText () {
        if (this.record !== null && typeof this.record.industryName !== 'undefined') {
          return `Not enough reviews to calculate industry ranking`
        }
        return 'Not enough reviews to calculate industry ranking'
      },
      hasPaidSubscription () {
          return typeof this.record !== 'undefined' && this.record.businessDetails.isPaid
      }
    },
    watch: {
      businessStatsLoaded () {
        if (this.businessDetailLoaded && this.businessStatsLoaded && this.adWait) {
          this.adWait = false
        }
      },
      businessDetailLoaded () {
        if (this.businessDetailLoaded && this.businessStatsLoaded && this.adWait) {
          this.adWait = false
        }
      },
      adWait () {
        if (!this.adWait) {
          this.adWait = true
          googletag.cmd.push(() => {
            const stats = parseFloat(this.stats.reviewAverage).toFixed(2)
            const bName = this.record.businessDetails.name
            googletag.pubads().setTargeting('Pagetype', this._routeName)
            googletag.pubads().setTargeting('URL', window.location.href)
            googletag.pubads().setTargeting('Average Score', stats)
            googletag.pubads().setTargeting('Brand', bName)
            googletag.pubads().collapseEmptyDivs()
            googletag.enableServices()
          })
        }
      }
    },
    methods: {
      triggerPaginator () {
        window.googletag.cmd.push(() => {
          window.googletag.destroySlots()
        })
        this.adWait = false
      },
      ratingFilterChanged (event) {
        this.selectedStarFilter = parseInt(event) || 0
        if (this.selectedStarFilter === 0) {
          this.filter_search = ''
        } else {
          this.filter_search = event.join(',')
        }
        this.fetchReviews(1)
      },
      keywordChanged (keyword) {
        let searchTerm = keyword.target.value
        if (searchTerm.trim().length > 0) {
          this.keyword_search = qs.stringify({keyword: searchTerm.trim()})
        } else {
          this.keyword_search = ''
        }
        this.fetchReviews(1)
      },
      async fetchReviews (page) {
        const reviewFetchUrl = this.url(page, this.keyword_search, this.filter_search)
        if (reviewFetchUrl !== this.current_review_fetch_url) {
          if (!page) {
            this.triggerPaginator()
          }
          this.current_review_fetch_url = reviewFetchUrl
          this.fetching_data = true
          axios.get(this.url(page, this.keyword_search, this.filter_search))
            .then((response) => {
              this.fetching_data = false
              this.reviews_per_page = response.data.per_page
              this.dataSet = response.data
              this.items = response.data.data
              this.pagination.current_page = response.data.current_page
              this.pagination.last_page = response.data.last_page
              window.scrollTo(0, 0)
            })
            .catch(() => {
              this.fetching_data = false
            })
        }
      },
      url (page, keyword, filter) {
        if (!page) {
          let query = location.search.match(/page=(\d+)/)

          page = query ? query[1] : 1
        }

        if (keyword.length > 0) {
          page += `&${keyword}`
        }

        if (filter.length > 0) {
          page += `&ratings=${filter}`
        }

        return `/consumer/business/${this.business}/reviews?page=${page}`
      },
      changeMobileTabs () {
        window.googletag.cmd.push(() => {
          window.googletag.destroySlots()
        })
        this.showReviewTab = !this.showReviewTab
        this.showDetailsTab = !this.showDetailsTab
        this.adWait = false
      },
      showRatingsChart () {
        return this.$parent.$options.methods.showRatingsChart()
      },
      digitToWords(num)
      {
          let a = ['','one','two','three','four','five','six','seven','eight','nine','ten','eleven','twelve','thirteen','fourteen','fifteen','sixteen','seventeen','eighteen','nineteen', 'twenty'];
          if ((num = num.toString()).length > 9) return 'overflow';
          let n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
          if (!n) return;
          return a[Number(n[5])]
      },
    }
  }
</script>
<style scoped>
  .filter-text {
    color: #707070;
    font-size: 0.8rem;
  }

  p {
    color: #707070;
    font-size: 0.9rem;
    margin-bottom: 4px;
  }

  .input {
    color: #58595B;
    border: 1px solid #DBDBDB;
    border-radius: 0;
    font-size: 0.8rem;
    height: 40px;
    padding-left: 1rem;
    box-shadow: none;
  }

  .icon {
    color: #2EAAE1!important;
    font-size: 0.9rem;
    height: 40px!important;
  }

  .field {
    margin-bottom: 20px;
  }

  .columns.is-multiline.is-hidden-tablet > .column:last-child {
    border-bottom: 1px solid #C9C9C9;
  }

  .columns.is-hidden-tablet.is-full-mobile {
    margin-top: -60px;
  }

  .tabs {
    background-color: #F5F5F5;
    margin-bottom: 25px;
  }

  .tabs > ul {
    border: none;
  }

  .tabs > ul > li > a {
    color: #58595B;
    font-size: 0.9rem;
    border-bottom: none;
    padding: 0.7rem 1rem;
  }

  .tabs > ul > li.is-active > a {
    color: #2EAAE1;
    border-bottom: 3px solid #2EAAE1;
  }

  .container-box {
    display: block;
    width: 174px;
    box-shadow: 0px 0px 23px -1px rgba(166,159,166,0.32);
    padding: 0.7rem;
  }

  .container-box > p {
    width: 100%;
    display: block;
    padding: 0;
    text-align: center;
  }

  .container-box > p:nth-child(odd) {
    font-size: 0.75rem;
  }

  .container-box > p:nth-child(even) {
    font-size: 2.5rem;
  }

  .nps-total {
    display: block;
    width: 68px;
    height: 68px;
    border: 5px solid #2FABE1;
    border-radius: 50%;
    font-size: 1.4rem;
    text-align: center;
    line-height: 60px;
    margin: 6px auto;
  }

  .no-nps-data {
    display: block;
    width: 68px;
    height: 68px;
    color: #707070;
    font-size: 0.9rem!important;
    text-align: center;
    line-height: 30px;
    margin: 20px auto;
  }

  .level > .level-item.container-box:last-child > p {
    font-size: 0.65rem;
  }

  .level > .level-item:not(:last-child) {
    margin-right: 1.5rem;
  }

  .error-message{
    padding-bottom: 12px;
  }

  @media screen and (max-width: 1024px) {
    .business-logo {
      width: 111px;
    }

    .section.business-summary {
      padding: 3rem 1.3rem;
    }

    .responding-business {
      width: 34px;
      position: relative;
      margin-left: -50px;
      margin-bottom: -80px;
      margin-right: 5px;
    }

    .business-name {
      font-size: 1rem;
    }

    .industry {
      font-size: 0.8rem;
    }

    .review-summary {
      font-size: 0.75rem;
    }

    .summary {
      max-width: 150px;
      line-height: 1.2rem;
    }

    .container-box {
      width: 114px;
      height: 136px;
    }
  }

  @media screen and (max-width: 767px) {

    .section.business-summary {
      padding: 1.3rem;
    }

    .business-logo {
      width: 75px;
      position: relative;
      top: -20px;
    }

    .responding-business {
      width: 23px;
      position: relative;
      margin-left: -40px;
      margin-bottom: -12px;
      margin-right: 5px;
    }

    .summary-trust-index {
      font-size: 0.9rem;
      line-height: 2rem;
      position: relative;
      top: -20px;
    }

    .summary {
      width: 100%;
    }

    .review-count {
      font-size: 0.75rem;
      position: relative;
      left: 130px;
      top: -20px;
    }

    .section.business-columns {
      border: none;
    }

    h4 {
      margin-top: 2rem;
      margin-bottom: 1rem;
    }

    .industry-rank-card {
      box-shadow: 0 0 23px -1px rgba(166,159,166,0.32)
    }

    .columns.is-mobile > .industry-rank-card {
      margin-right: 20px;
    }

    .columns.is-mobile > .industry-rank-card:last-child {
      margin-right: 0;
    }

    .button {
      border: 0;
      border-radius: 0;
      background-color: #30AAE1;
      color: #ffffff;
      font-size: 0.85rem;
      padding: 1.3rem 2rem;
    }

    .level.is-mobile ~ .container {
      color: #58595B;
    }

    .container > .mini-title {
      margin-top: 1rem;
    }

    .social-facebook, .social-twitter, .social-linkedin, .social-google, .social-instagram {
      color: #ffffff;
      display: block;
      width: 33px;
      height: 33px;
      border-radius: 50%;
      font-size: 1.3rem;
      line-height: 33px;
      text-align: center;
      margin-left: auto;
      margin-right: auto;
    }

    .social-facebook {
      background-color: #3B5998;
    }
    .social-twitter {
      background-color: #00ACED;
    }
    .social-linkedin {
      background-color: #0E76A8;
    }
    .social-google {
      background-color: #D34836;
    }
    .social-instagram {
      background-color: #FB3958;
    }

    .tag.is-white {
      margin-right: 10px;
      margin-bottom: 10px;
      color: #707070;
      background-color: #F5F5F5;
      border-radius: 0;
    }

    .business-description {
      margin-bottom: 1.5rem!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/business/BusinessReviews.vue